// vendor

import Swiper, {
  Navigation, Pagination, EffectFade, Autoplay, Thumbs,
} from 'swiper/core';

// components
import Reviews from './partials/reviews';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Thumbs]);

class JobsDetail {
  constructor() {
    this.dom = {
      reviewsSlider: document.querySelector('.reviews-slider'),
      reviewsPeopleSlider: document.querySelector('.reviews-people-slider'),
    };

    this.components = {
      reviewsSlider: null,
    };

    this.mount();
  }

  mount() {
    // init review swiper
    if (this.dom.reviewsSlider && this.dom.reviewsPeopleSlider) {
      setTimeout(() => {
        this.components.reviewsSlider = new Reviews(this.dom.reviewsSlider, this.dom.reviewsPeopleSlider);
      }, 100);
    }
  }
}

if (document.getElementById('page-jobs-detail')) {
  // eslint-disable-next-line no-new
  new JobsDetail();
}
